import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const productDisclosuresSelector = createSelector(testTargetOffersSelector, offers => offers.productDisclosures || Empty.Object);

export { productDisclosuresSelector };
